import { PortfolioProject } from '../../types';
import { PortfolioProjectSource, Currency } from '../../../gql-operations/gql-generated';

export const WORKSAMPLE_LOWEST_PRICE = {
    amount: 50,
    currency: Currency.Usd,
};

export interface PortfolioProjectPrice {
    amount: number;
    currency: Currency;
}

export type ProjectPriceData = Pick<PortfolioProject, 'price' | 'source'>;

const getStartingPrice = (projects: ProjectPriceData[], allProjectsPricing?: PortfolioProjectPrice) => {
    const filteredProjects = projects.filter((project) => {
        const projectPrice = Number(project.price?.amount);
        return (
            project.source === PortfolioProjectSource.External ||
            (project.source === PortfolioProjectSource.Internal &&
                !isNaN(projectPrice) &&
                projectPrice > WORKSAMPLE_LOWEST_PRICE.amount)
        );
    });

    if (filteredProjects.length === 0) {
        return allProjectsPricing;
    }

    const result = filteredProjects.reduce(
        (acc, project) => {
            const projectPrice = Number(project.price?.amount);
            return projectPrice < acc.amount
                ? {
                      amount: projectPrice,
                      currency: project.price?.currency || Currency.Usd,
                  }
                : acc;
        },
        {
            amount: Infinity,
            currency: Currency.Usd,
        }
    );

    return isFinite(result.amount) ? result : WORKSAMPLE_LOWEST_PRICE;
};

export const getStartingPriceForAllProjects = (projects: ProjectPriceData[]) => getStartingPrice(projects);

export const getStartingPriceForFilteredProjects = (
    projects: ProjectPriceData[],
    allProjectsPricing?: PortfolioProjectPrice
) => getStartingPrice(projects, allProjectsPricing);
